import {
  mapToKey,
  searchByName,
  sortAlphabeticalByName,
} from '@witmetrics/utils/arrays';
import type {
  DecoratedUserLab,
  DecoratedUserPractice,
} from '@witmetrics/utils';
import { API } from '@/api';

export const classes = {
  panel: 'px-[44px] pb-[34px] pt-[44px]',
  search: 'mb-[30px]',
  grid: 'grid items-start gap-[26px]',
  gridDual: 'grid-cols-2',
  gridSingle: 'grid-cols-1',
  colHead: 'mb-[13px] flex items-center gap-2',
  colLabel:
    'text-[12px] font-extrabold uppercase tracking-[0.06em] text-taupe-1 dark:text-mauve-2',
  colCount:
    'rounded-full bg-black/[0.08] px-2 py-px text-[11px] font-bold text-taupe-1 dark:bg-white/[0.08] dark:text-mauve-2',
  list: 'flex max-h-[344px] flex-col gap-2.5 overflow-y-auto pr-1',
};

export function filterPractices(
  userPractices: DecoratedUserPractice[],
  search: string
) {
  return sortAlphabeticalByName(
    searchByName(mapToKey(userPractices, 'practice'), search)
  );
}

export function filterLabs(userLabs: DecoratedUserLab[], search: string) {
  return sortAlphabeticalByName(
    searchByName(mapToKey(userLabs, 'lab'), search)
  );
}

export function fetchAccountTrials() {
  return API.Trials.fetchCurrentUserTrials();
}
